import { observer } from 'mobx-react-lite'
import { TotalAllocatedStatus } from '@/features/jobs/details/components/PayoutSplitAllocator/TotalAllocatedStatus'
import { type PayoutSplitAllocatorViewModel } from '@/features/jobs/details/components/PayoutSplitAllocator/PayoutSplitAllocatorViewModel'

export interface TotalAllocatedStatusContainerProps {
  vm: PayoutSplitAllocatorViewModel
}

export const TotalAllocatedStatusContainer = observer(
  function TotalAllocatedStatusContainer({
    vm,
  }: TotalAllocatedStatusContainerProps) {
    return (
      <TotalAllocatedStatus
        allocatedTotal={vm.allocatedTotal}
        payoutTotal={vm.payoutTotal}
      />
    )
  },
)
